import React, { Fragment, useEffect, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import DescripcionAutoevaluacion from "./DescripcionAuto";

function InfromacionAutoevaluacion(props) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };

  const [list, setList] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/QSubtituloSolicitud?SolicitudId=" +
        props.idSolicitud,
    })
      .then((Response) => {
        setList(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList]);

  const [list1, setList1] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerAdjuntoAutoEvaluacion?SolicitudId=" +
        props.idSolicitud +
        "&SubtituloId=" +
        props.subTitulo,
    })
      .then((Response) => {
        setList1(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList1]);
  return (
    <div>
      <div className="container">
        <div className="text-center">
          <div class="container-fluid">
            <div class="card shadow mb-4">
              <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">
                  Información Autoevaluacion
                </h6>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <table
                    class="table table-bordered"
                    id="dataTable"
                    width="100%"
                    cellspacing="0"
                  >
                    <thead>
                      <tr>
                        <th>Seccion</th>
                        <th>Titulo</th>
                        <th>SubTitulo</th>
                        <th>Descripción</th>
                      </tr>
                    </thead>
                    <tbody>
                      {list.map((item) => {
                        return (
                          <tr>
                            <td>{item.nombreSeccion}</td>
                            <td>{item.titulo}</td>
                            <td>{item.subtitulo}</td>

                            <td>
                              <DescripcionAutoevaluacion
                                idSolicitud={props.idSolicitud}
                                SubId={item.subtituloId}
                                subtitulo={item.idSubtitulo}
                              />{" "}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InfromacionAutoevaluacion;
